import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';

import './form-item-fn-temporary-resident-banking.component.scss';

export class FormItemFnTemporaryResidentBanking extends Base {
	// form
	form: HTMLFormElement;
	wizard: HTMLFormElement;

	// form sections
	formLoader: Element;
	formFields: Element;
	formThankyou: Element;
	customHeading: HTMLFormElement;

	// inputs
	countryOfOriginSelection: HTMLFormElement;
	identificationSelection: HTMLFormElement[];
	countryCodeSelect: HTMLFormElement;
	countryCodeInput: HTMLFormElement;
	phoneNumberInput: HTMLFormElement;
	identificationType: string;
	isInSouthAfricaSelection: HTMLFormElement[];
	isInSouthAfrica: string;
	saArrivalDatePicker: Element;
	
	// buttons
	buttonSubmit: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.countryOfOriginSelection = this.element.querySelector('select[name=id-country-of-origin]');
		this.identificationSelection = Array.from(this.element.querySelectorAll('.js-identification_radio--group'));
		this.isInSouthAfricaSelection = Array.from(this.element.querySelectorAll('input[name=is-in-south-africa'));
		this.saArrivalDatePicker = this.element.querySelector('.js-date-picker');
		
		this.countryCodeSelect = this.element.querySelector('select[name=country-code-select]');
		this.countryCodeInput = this.element.querySelector('.fn-temporary-resident-banking__code');
		this.phoneNumberInput = this.element.querySelector('input[name=phone-number]');
		this.identificationType = '06';
		this.isInSouthAfrica = 'YES';

		this.formLoader = this.element.querySelector(".form__loader--container");
		this.formFields = this.element.querySelector(".form__fields--container");
		this.formThankyou = this.element.querySelector(".form__thankyou--container");
		this.customHeading = this.element.querySelector(".customHeading");

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.buttonSubmit = this.element.querySelector('.js_step-submit-button');

		this.wizard = this.element.querySelector('.form-container-wizard__wizard');

		let countryOfBirthSelect : HTMLSelectElement = this.form.querySelector('select[name=country-of-birth]');
		let countryOfOriginSelect : HTMLSelectElement = this.form.querySelector('select[name=id-country-of-origin]');
		let countryCodeSelect : HTMLSelectElement = this.form.querySelector('select[name=country-code-select]');
		//Get Json Data
		const countriesJson = '/file_source/assets/mri/cntry.json';
		const countryCodesJson = '/file_source/assets/mri/cntrycodes.json';

		//Set country of birth drop down
		const requestCountries = new XMLHttpRequest();
		requestCountries.open('GET', countriesJson, true);			

		requestCountries.onload = function() {
			if (requestCountries.status === 200) {
				const data = JSON.parse(requestCountries.responseText);
				let option;
				for (let i = 0; i < data.length; i++) {
					option = document.createElement('option');
					option.text = data[i].name;
					option.value = data[i].code;
					countryOfBirthSelect.add(option);
				}
			} else {
				// Error
				console.log("Error");
			}   
		}

		requestCountries.onerror = function() {
		console.error('An error occurred fetching the JSON from ' + countriesJson);
		};

		requestCountries.send();

		//Set country of origin drop down
		const requestCountries2 = new XMLHttpRequest();
		requestCountries2.open('GET', countriesJson, true);

		requestCountries2.onload = function() {
			if (requestCountries2.status === 200) {
				const data = JSON.parse(requestCountries2.responseText);
				let option;
				for (let i = 0; i < data.length; i++) {
					option = document.createElement('option');
					option.text = data[i].name;
					option.value = data[i].code;
					countryOfOriginSelect.add(option);
				}
			} else {
				// Error
				console.log("Error");
			}   
		}

		requestCountries2.onerror = function() {
		console.error('An error occurred fetching the JSON from ' + countriesJson);
		};

		requestCountries2.send();

		//Set country codes dropdown
		const requestCountryCodes = new XMLHttpRequest();
		requestCountryCodes.open('GET', countryCodesJson, true);

		requestCountryCodes.onload = function() {
			if (requestCountryCodes.status === 200) {
				const data = JSON.parse(requestCountryCodes.responseText);
				let option;
				for (let i = 0; i < data.length; i++) {
					option = document.createElement('option');
					option.text = data[i].name;
					option.value = data[i].shortname;
					option.setAttribute('data-code', data[i].code);
					countryCodeSelect.add(option);
				}
			} else {
				// Error
				console.log("Error");
			}   
		}

		requestCountryCodes.onerror = function() {
		console.error('An error occurred fetching the JSON from ' + countryCodesJson);
		};

		requestCountryCodes.send();

		this.updateFormIdPassport(this.identificationType);
		this.updateIsInSouthAfrica(this.isInSouthAfrica);
	}

	bindEvents() {
		this.identificationSelection.map((item) => item.addEventListener('click', (event) => {
			const evt: any = event.target;
			const identificationField: any = this.form.querySelector('input[name=identification]');
			this.identificationType = evt.value;

			if (this.identificationType === '01') {
				identificationField.classList.remove('form__input--identification--passport');
				identificationField.classList.add('form__input--identification');
				identificationField.placeholder = 'Enter your South African ID number';
				identificationField.value = "";
				identificationField.type = 'number';
			} else {
				identificationField.classList.remove('form__input--identification');
				identificationField.classList.add('form__input--identification--passport');
				identificationField.placeholder = 'Enter your Passport number';
				identificationField.value = "";
				identificationField.type = 'text';
			}
			this.updateFormIdPassport(this.identificationType);
		}));

		this.countryCodeSelect.addEventListener('change', (event) => {
			const evtTarget: any = event.target;
			this.countryCodeInput.innerHTML = "";
			if (evtTarget.value) {
				this.countryCodeInput.innerHTML = "+" + evtTarget.options[evtTarget.selectedIndex].getAttribute('data-code');
			}
			
		});

		this.isInSouthAfricaSelection.map((item) => item.addEventListener('click', (event) => {
			const evt: any = event.target;
			this.isInSouthAfrica = evt.value;

			this.updateIsInSouthAfrica(this.isInSouthAfrica);
		}));

		if (this.buttonSubmit) {
			this.buttonSubmit.addEventListener('click', (event) => {
				const _button = event.target as HTMLFormElement;
				const _form = _button.closest('form') as HTMLFormElement;
				const formFields: any = _form.querySelectorAll('input, select');
				this.validationService.validate(formFields);

				//Manual Validation for reCaptcha Form Element
				let reCaptchaValid = false;
				let reCaptchaFormField = _form.querySelector('.g-recaptcha');
				let formRecaptchaResponseField: any = this.form.querySelector('.g-recaptcha-response');
				reCaptchaValid = (formRecaptchaResponseField.value != null && formRecaptchaResponseField.value != "") ? true : false;
				this.validationService.validateReCaptcha(reCaptchaValid, reCaptchaFormField);

				const valid = Array.from(_form.querySelectorAll(".form__group--error"));

				if (valid.length == 0 && reCaptchaValid) {
					this.submitForm(_form);
				}
			});
		}
		
		// Reset the form
		this.form.addEventListener('custom_form_reset_event', (e) => {
			// allow individual form items components to handle form reset
			if (this.wizard) {
				const event = new CustomEvent('custom_wizard_reset_event');
				this.wizard.dispatchEvent(event);
			}

			//Recapture Reset
			const gcaptcha = this.form.querySelectorAll('.g-recaptcha-response');
			if (gcaptcha) {
				gcaptcha.forEach(element => {
					var newElem = element as HTMLFormElement;
					newElem.value = "";
				});
			}

			const btnRestartReCaptcha : HTMLFormElement = this.form.querySelector("a[name=btnRestartReCaptcha]");
			if (btnRestartReCaptcha) {
				btnRestartReCaptcha.click();
			}

		}, false);
	}

	updateFormIdPassport(value) {
		if (this.countryOfOriginSelection) {
			const _countryOfOriginSelectGroup = this.countryOfOriginSelection.closest(".form__group");
			if (value == '01') {
				this.countryOfOriginSelection.classList.remove("form__input--required");
				_countryOfOriginSelectGroup.classList.add('form__group--hidden');
			}
			else {
				_countryOfOriginSelectGroup.classList.remove('form__group--hidden');
				this.countryOfOriginSelection.classList.add("form__input--required");
				
			}
		}
	}

	updateIsInSouthAfrica(value) {
		if (this.isInSouthAfricaSelection.length > 0 && this.saArrivalDatePicker) {
			const _datePickerSelectGroup = this.saArrivalDatePicker.closest(".form__group");
			const _isInSouthAfricaSelectionGroup = this.isInSouthAfricaSelection[0].closest(".form__group");
			
			if (_datePickerSelectGroup && _isInSouthAfricaSelectionGroup) {
				if (value == 'YES') {
					this.saArrivalDatePicker.classList.remove("form__input--required");
					_datePickerSelectGroup.classList.add('form__group--hidden');
					_isInSouthAfricaSelectionGroup.setAttribute('style', 'padding: 0 0 25px 0;');
				}
				else {
					_datePickerSelectGroup.classList.remove('form__group--hidden');
					this.saArrivalDatePicker.classList.add("form__input--required");
					_isInSouthAfricaSelectionGroup.setAttribute('style', 'padding: 0 0 15px 0;');
				}
			}
		}
	}

	submitForm(form: HTMLFormElement) {
		// success screens
		const loader = form.querySelector('.form__loader--container');
		const thankYou = form.querySelector('.form__thankyou--container');
		const success = form.querySelector('.form__success--container');
		const error = form.querySelector('.form__error--container');
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		let name = Array.from(form.querySelectorAll('.form__success-container__firstname'));

		let postData = '';

		let serviceType: any = form.querySelector("input[name=service-type]");
		if (serviceType) {
			postData += "&service-type=" + serviceType.value;
		}
		let description: any = form.querySelector("input[name=description]");
		if (description) {
			postData += "&description=" + description.value;
		}
		let email: any = form.querySelector("input[name=email]");
		if (email) {
			postData += "&email=" + email.value;
		}
		let recipient: any = form.querySelector("input[name=recipient]");
		if (recipient) {
			postData += "&recipient=" + recipient.value;
		}
		let subject: any = form.querySelector("input[name=subject]");
		if (subject) {
			postData += "&subject=" + subject.value;
		}
		let product: any = form.querySelector("input[name=product]");
		if (product) {
			postData += "&productName=" + product.value;
		}
		let redirect: any = form.querySelector("input[name=redirect]");
		if (redirect) {
			postData += "&redirect=" + redirect.value;
		}
		let _nameTitle: any = this.form.querySelector('select[name=name-title]');
		if (_nameTitle) {
			postData += "&namePrefix=" + _nameTitle.value;
		}
		let _firstname: any = this.form.querySelector('input[name=first-name]');
		if (_firstname) {
			postData += "&firstname=" + _firstname.value;
		}
		let _surname: any = this.form.querySelector('input[name=last-name]');
		if (_surname) {
			postData += "&surname=" + _surname.value;
		}
		let _identificationType: any = this.identificationType;
		if (_identificationType) {
			postData += "&idType=" + _identificationType;
		}
		let _identificationNumber: any = this.form.querySelector('input[name=identification]');
		if (_identificationNumber) {
			postData += "&idNumber=" + _identificationNumber.value;
		}
		if (_identificationType) {
			if (_identificationType == "06") {
				let _idCountryOfOrigin: any = this.form.querySelector('select[name=id-country-of-origin]');
				if (_idCountryOfOrigin) {
					postData += "&idCountryCd=" + _idCountryOfOrigin.value;
				}
			}
			else if (_identificationType == "01") {
				postData += "&idCountryCd=ZA";
			}
			else {
				postData += "&idCountryCd=";
			}
		}
		let _countryOfBirth: any = this.form.querySelector('select[name=country-of-birth]');
		if (_countryOfBirth) {
			postData += "&birthCountryCd=" + _countryOfBirth.value;
		}
		let _countryCode: any = this.form.querySelector('select[name=country-code-select]');
		if (_countryCode) {
			postData += "&phoneCountryCd=" + _countryCode.value;
		}
		let _contactNumber: any = this.form.querySelector('input[name=phone-number]');
		if (_contactNumber) {
			postData += "&contact=" + _contactNumber.value;
		}
		let _emailAddress: any = this.form.querySelector('input[name=email-address]');
		if (_emailAddress) {
			postData += "&emailAddress=" + _emailAddress.value;
		}
		let _isInSouthAfrica: any = this.isInSouthAfrica;
		if (_isInSouthAfrica) {
			postData += "&in-SouthAfrica=" + _isInSouthAfrica;
		}
		let _expectedDateOfArrival: any = this.element.querySelector('.js-date-picker');
		if (_expectedDateOfArrival) {
			postData += "&expected-Arrival-Date=" + _expectedDateOfArrival.value;
		}
		let _fraudCheckConsent: any = this.form.querySelector('input[name=fraud-check-consent]');
		if (_fraudCheckConsent) {
			postData += "&consent=" + 'YES';
		}
		let _formRecaptchaResponse: any = this.form.querySelector('.g-recaptcha-response');
		if (_formRecaptchaResponse) {
			postData += "&g-recaptcha-response=" + _formRecaptchaResponse.value;
		}

		// loader + hide form
		this.formLoader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/foreignnationalsservice.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			loader.classList.remove('active');
			if (!response.data || (response.data.toString().includes('invalid')) 
			|| (response.data.toString().includes('error')) || response.data['success'].toString() == 'false') {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
				thankYou.classList.add('active');
				success.classList.remove('active');
				success.classList.add('hidden');
				error.classList.remove('hidden');
				error.classList.add('active');
			} else {
				if (response.code) {
					analyticsService.dtmFormComplete('complete', response.code);
				} else if (response.status) {
					analyticsService.dtmFormComplete('complete', response.status);
				} else {
					analyticsService.dtmFormComplete('complete', "200");
				}
				thankYou.classList.add('active');
				error.classList.remove('active');
				error.classList.add('hidden');
				success.classList.remove('hidden');
				success.classList.add('active');
			}
		}).catch(response => {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});

		this.resetForm();
	}

	resetForm() {
		this.identificationType = '06';
		this.isInSouthAfrica = 'YES';
		const identificationField: any = this.form.querySelector('input[name=identification]');

		identificationField.classList.remove('form__input--identification');
		identificationField.classList.add('form__input--identification--passport');
		identificationField.placeholder = 'Enter your Passport number';
		identificationField.value = "";
		identificationField.type = 'text';

		this.countryCodeInput.innerHTML = "";
		
		let formRecaptchaResponseFields: any = this.form.querySelectorAll('.g-recaptcha-response');
		formRecaptchaResponseFields.forEach(element => {
			var newElem = element as HTMLFormElement;
			newElem.value = "";
		});

		const btnRestartReCaptcha : HTMLFormElement = this.form.querySelector("a[name=btnRestartReCaptcha]");
		if (btnRestartReCaptcha) {
			btnRestartReCaptcha.click();
		}

		this.updateFormIdPassport(this.identificationType);
		this.updateIsInSouthAfrica(this.isInSouthAfrica);
	}
}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-fn-temporary-resident-banking/form-item-fn-temporary-resident-banking.component.ts